import React from "react";
import Moment from "react-moment";
import toast from "react-hot-toast";
import fileDownload from "js-file-download";
import axiosConfig from "../axiosConfig";
import Accordion from "../components/Accordion";
import Button from "../components/Button";
import WebsitePageHeader from "../components/WebsitePageHeadings";
import DocumentIcon from "../features/documents/components/DocumentIcon";
import LoadingSpinner from "../features/portfoliovaluation/components/LoadingSpinner";
import { useSession } from "../components/SessionContext";

const DocumentUploadDate = ({ date = '2026-06-26' }) => <Moment date={date} format="MMMM Do yyyy" />;

const DocumentAccordionTitle = ({ title, count }) => (
    <div className="flex flex-1 justify-between items-center me-3">
        <span>{title}</span>
        <span>{count} document(s)</span>
    </div>
);

const DocumentAccordionContent = ({ name, fileName, fileType = 0 }) => {
    const [isDownloading, setIsDownloading] = React.useState(false);
    const { accessToken } = useSession();

    const getDocument = () => {
        if (!accessToken) {
            toast.error("Could not download file. You do not have the required permissions to access this file.");
            return;
        }

        setIsDownloading(true);
        axiosConfig.get(`api/downloads/${fileName}`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            },
            responseType: "blob",
        })
        .then((res) => {
            if (res.status !== 200) {
                toast.error('There was an error whilst trying to get your file.');
                return;
            }
            fileDownload(res.data, fileName);
        })
        .catch(() => {
            toast.error("Could not download file. You do not have the required permissions to access this file.");
        })
        .finally(() => {
            setIsDownloading(false);
        });
    };

    return (
        <div className="flex flex-col md:flex-row md:items-center border-b border-slate-300 px-4 md:px-0 py-4">
            <div className="mx-6 hidden md:block">
                <DocumentIcon fileType={fileType} />
            </div>
            <p className="flex-1 leading-none">
                <DocumentIcon className="me-3 md:hidden" fileType={fileType} />
                <span className="text-md">{name}</span>
                <br />
                <span className="text-xs text-slate-500">
                    Uploaded{" "}
                    <DocumentUploadDate />
                </span>
            </p>
            <div className="me-6">
                <Button onClick={getDocument}>{!isDownloading ? (<>Download</>) : (<LoadingSpinner width={3} height={3} />)}</Button>
            </div>
        </div>
    )
};

const ShackletonDocumentsPage = () => (
    <div className="flex flex-col gap-3 p-4">
        <WebsitePageHeader>Shackleton Documents</WebsitePageHeader>
        <div>
            <Accordion title={(<DocumentAccordionTitle title="Terms & Conditions" count="1" />)}>
                <DocumentAccordionContent name="Shackleton T&Cs 26.11.24.pdf" fileName="Shackleton T&Cs 26.11.24.pdf" fileType={0} />
            </Accordion>
        </div>
        <div>
            <Accordion title={(<DocumentAccordionTitle title="Key Feature Documents" count="4" />)}>
                <DocumentAccordionContent name="KFD - Shackleton Hub GIA 2025.pdf" fileName="KFD - Shackleton Hub GIA 2025.pdf" fileType={0} />
                <DocumentAccordionContent name="KFD - Shackleton Hub ISA 2025.pdf" fileName="KFD - Shackleton Hub ISA 2025.pdf" fileType={0} />
                <DocumentAccordionContent name="KFD - Shackleton Hub JISA 2025.pdf" fileName="KFD - Shackleton Hub JISA 2025.pdf" fileType={0} />
                <DocumentAccordionContent name="KFD - SS_C Hubwise SIPP 2025.pdf" fileName="KFD - SS_C Hubwise SIPP 2025.pdf" fileType={0} />
            </Accordion>
        </div>
    </div>
);

export default ShackletonDocumentsPage;